import Component from 'flarum/common/Component';
import LinkButton from 'flarum/common/components/LinkButton';
import classList from 'flarum/common/utils/classList';
import { isLinkActive, linkHref } from '../utils/linkTarget';
export default class LinkItem extends Component {
  /**
   * Read by `listItems`, which marks the `<li>` around an active item. Core
   * highlights an active menu entry from there.
   */
  static isActive(attrs) {
    return isLinkActive(attrs.link);
  }
  view(vnode) {
    const link = this.attrs.link;
    const title = link.title();
    const active = isLinkActive(link);
    return m(LinkButton, {
      className: classList('LinksButton', this.attrs.className, !this.attrs.inDropdown && 'Button Button--link'),
      href: linkHref(link),
      external: !link.isNewtab() && !link.isInternal(),
      target: link.isNewtab() ? '_blank' : undefined,
      rel: this.rel(),
      icon: link.icon() || undefined,
      active: active,
      "aria-current": active ? 'page' : undefined
      // Kept for when the title is hidden to leave only the icon.
      ,
      "aria-label": title
    }, m("span", {
      className: "LinksButton-title",
      "data-title": title
    }, title));
  }
  rel() {
    const link = this.attrs.link;
    return classList(link.isNewtab() && 'noopener noreferrer', link.useRelMe() && 'me') || undefined;
  }
}
flarum.reg.add('fof-links', 'forum/components/LinkItem', LinkItem);